import { Tool } from '../../types';

export const propertyManagementTools: Tool[] = [
  {
    id: 'appfolio',
    name: 'AppFolio',
    category: 'Property Management',
    description: 'Modern property management software with comprehensive features',
    pricing: ['medium', 'high'],
    features: ['automation', 'mobile', 'integrations', 'document-management'],
    bestFor: ['small-business'],
    compatibleWith: ['service-business', 'real-estate', 'property-management'],
    goals: ['streamline-operations', 'automate-tasks', 'enhance-customer-service'],
    industries: ['real-estate', 'property-management'],
    website: 'https://www.appfolio.com',
    imageUrl: 'https://logo.clearbit.com/appfolio.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'buildium',
    name: 'Buildium',
    category: 'Property Management',
    description: 'All-in-one property management software for real estate businesses',
    pricing: ['medium', 'high'],
    features: ['automation', 'mobile', 'integrations', 'document-management'],
    bestFor: ['small-business'],
    compatibleWith: ['service-business', 'real-estate'],
    goals: ['streamline-operations', 'automate-tasks', 'enhance-customer-service'],
    industries: ['real-estate', 'property-management'],
    website: 'https://www.buildium.com',
    imageUrl: 'https://logo.clearbit.com/buildium.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];